// Pure add-card routing decisions, kept out of the component file.
//
// A file that exports both a component and non-components cannot preserve state
// across Fast Refresh (react-doctor/only-export-components), and the whole point of
// these two is to be testable without mounting the modal. Same reason
// overview/razorpay-card-entry.ts exists.

// Mirrors the render-branch order below: Razorpay wins, then Cashfree, then
// Stripe. Pure so the funnel label can't drift from which modal actually opened.
export const resolveAddCardGateway = ({
  isRazorpay,
  isCashfree,
}: {
  isRazorpay: boolean
  isCashfree: boolean
}): string => {
  if (isRazorpay) return 'razorpay'
  if (isCashfree) return 'cashfree'
  return 'stripe'
}

// Which add-card surface to open.
//
// Pure so the LOAD WINDOW is testable. useBillingGateway reports 'stripe' until
// account details resolve, so an INR account clicking "Add card" before then had
// isRazorpay === false. The embedded branch already waited for accountDetails; the
// LEGACY branch — the default, since isEmbeddedCardCheckoutEnabled defaults false —
// did not, and rendered the raw Stripe form. INR does not support Stripe at all, so
// nothing gateway-specific may render before the currency is known.
export type AddCardSurface =
  | 'loading'
  | 'razorpay'
  | 'cashfree-embedded'
  | 'stripe-embedded'
  | 'legacy'

export const resolveAddCardSurface = ({
  accountDetailsLoaded,
  isRazorpay,
  isCashfree,
  embeddedEnabled,
}: {
  accountDetailsLoaded: boolean
  isRazorpay: boolean
  isCashfree: boolean
  embeddedEnabled: boolean
}): AddCardSurface => {
  if (!accountDetailsLoaded) return 'loading'
  // Razorpay first, and ahead of the embedded flag: it has no $0 save-card endpoint,
  // so add-card there is a real charge through its own modal.
  if (isRazorpay) return 'razorpay'
  if (embeddedEnabled) return isCashfree ? 'cashfree-embedded' : 'stripe-embedded'
  return 'legacy'
}
